import SearchComponent from '@components/inputs/search/Search.component';
import { Colors } from '@constants/colors.constants';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useObservable } from '@ngneat/react-rxjs';
import { auditsFollowUpService } from '@store/audits/audit-offer-followUp/audit-offer-followUp.services';
import { auditOfferFollowUpQuery } from '@store/audits/audit-offer-followUp/audits-offer-followUp.query';
import { OfferFollowUpDetailsRoutes } from '@utils/routes.utils';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import OfferItem from './components/OfferItem';
import ScrollingList from './components/ScrollingList';

const RecentOffers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { auditId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [{ auditOfferFollowUp, loading }] = useObservable(auditOfferFollowUpQuery.auditOfferFollowUp$);

  useEffect(() => {
    if (auditId) {
      auditsFollowUpService.getAuditOfferFollowUp(auditId, true).subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
    }
  }, [auditId, enqueueSnackbar]);

  return (
    <Stack p="20px" height={'100%'} spacing={4}>
      <Stack spacing={2} pr={'10px'}>
        <Typography sx={{ color: Colors.black, fontWeight: 700, fontSize: '20px', textAlign: 'left' }}>
          {t('audits.auditOfferFollowUp.recentOffers.title', { value: auditOfferFollowUp.length })}
        </Typography>
        <SearchComponent
          isCustom
          value={''}
          handleChange={() => undefined}
          bgColor="#F4F6F8"
        />
      </Stack>
      {loading ? (
        <Stack p="20px" height={'100%'} spacing={4} justifyContent={loading ? 'center' : undefined}>
          <CircularProgress size={40} sx={{ alignSelf: 'center' }} />
        </Stack>
      ) : (
        <>
          <ScrollingList height={'100%'} spacing={2}>
            {auditOfferFollowUp
              .sort((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? -1 : 1)
              .map((it) => (
                <OfferItem key={it.id} item={it} handleClick={() => navigate(`${OfferFollowUpDetailsRoutes.DETAILS_OFFER}/${it.id}`)} />
              ))}
          </ScrollingList>
          <Outlet />
        </>
      )}
    </Stack>
  );
};

export default RecentOffers;